import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id DAD983AE-28E9-481D-B0F0-38E1EFD0CAFE
 * name file-settings
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-settings.svg
 * tags
 * - Settings 
 * - Files / Folders 
 */
export const FileSettingsIcon = createSvgIcon(<><path d="M6 0C4.89 0 4 .89 4 2V18A2 2 0 0 0 6 20H18A2 2 0 0 0 20 18V6L14 0H6M13 1.5L18.5 7H13V1.5M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15Z" /></>, 'FileSettingsIcon');
export default FileSettingsIcon